import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import {
  formatGender,
  formatOptionalId,
  resolveContact,
  resolveCountryLabel,
} from './kycConstants';

function InfoItem({ label, value }) {
  return (
    <p className="kyc-audit-info__item">
      <span className="kyc-audit-info__label">{label}：</span>
      <span>{value ?? '—'}</span>
    </p>
  );
}

export default function KycAuditModal({ open, row, onClose, onSaved }) {
  const [approved, setApproved] = useState(null);
  const [remark, setRemark] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open && row) {
      setApproved(null);
      setRemark('');
      setError('');
    }
  }, [open, row?.memberId]);

  if (!open || !row) {
    return null;
  }

  const canSubmit = approved === true || approved === false;
  const remarkRequired = approved === false;

  async function handleSubmit(event) {
    event.preventDefault();
    if (remarkRequired && !remark.trim()) {
      setError('審核不通過時須填寫備註');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await adminApi.kycAudit({
        memberId: row.memberId,
        approved,
        remark: remark.trim() || undefined,
      });
      onSaved?.();
      onClose();
    } catch (err) {
      setError(err.message || '審核失敗');
    } finally {
      setSubmitting(false);
    }
  }

  function handleReset() {
    setApproved(null);
    setRemark('');
    setError('');
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--kyc-audit"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>KYC 審核 [{formatOptionalId(row.memberId)}]</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <div className="kyc-audit-info">
              <InfoItem label="用戶ID" value={formatOptionalId(row.memberId)} />
              <InfoItem label="郵箱/手機號" value={resolveContact(row)} />
              <InfoItem label="國家" value={resolveCountryLabel(row)} />
              <InfoItem label="性別" value={formatGender(row.gender)} />
            </div>

            <div className="kyc-audit-form">
              <div className="kyc-audit-form__field">
                <span className="kyc-audit-form__label">
                  <span className="required">*</span> 審核結果
                </span>
                <div className="radio-row radio-row--inline">
                  <label>
                    <input
                      type="radio"
                      name="kycAuditDecision"
                      checked={approved === true}
                      onChange={() => setApproved(true)}
                    />
                    審核通過
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="kycAuditDecision"
                      checked={approved === false}
                      onChange={() => setApproved(false)}
                    />
                    審核不通過
                  </label>
                </div>
              </div>
              <div className="kyc-audit-form__field kyc-audit-form__field--remark">
                <span className="kyc-audit-form__label">
                  {remarkRequired && <span className="required">*</span>}
                  {' '}
                  備註
                </span>
                <input
                  id="kycAuditRemark"
                  type="text"
                  className="kyc-audit-remark-input"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  placeholder={remarkRequired ? '請輸入備註（將顯示於前台）' : '選填'}
                />
              </div>
            </div>

            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer admin-modal__footer--center">
            <button
              type="submit"
              className={`btn btn-success${canSubmit ? '' : ' is-disabled'}`}
              disabled={submitting || !canSubmit}
            >
              {submitting ? '提交中…' : '提交'}
            </button>
            <button type="button" className="btn btn-warning" onClick={handleReset}>
              重置
            </button>
            <button type="button" className="btn btn-danger" onClick={onClose}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
